/**
 * True when ratePeriod1 applies to the revolving term and ratePeriod2 applies to the amortizing term of a LOC.
 * Mirrors SecuredMetaDataLoan.HasAmortizingRatePeriod on the server.
 */
export function hasAmortizingRatePeriod(loan: api.SecuredMetaDataLoan) {
	return canSeparateAmortizingRate(loan) && !!loan.separateAmortizingRate;
}

/** True when amortizing term rate data is stored, whether or not it currently applies. */
export function hasAmortizingRateData(loan: api.SecuredMetaDataLoan) {
	return loan.separateAmortizingRate != null
		|| !!loan.amortizingFirstRateAdj
		|| Object.values(loan.ratePeriod2 || {}).some(v => v != null && v !== '');
}

/**
 * Removes amortizing term rate data. Mutates the loan (use inside a store update).
 * Mirrors SecuredMetaDataLoan.ClearInapplicableAmortizingRate on the server.
 */
export function clearAmortizingRate(loan: api.SecuredMetaDataLoan) {
	loan.separateAmortizingRate = undefined;
	loan.amortizingFirstRateAdj = undefined;
	loan.ratePeriod2 = {};
}

/** True when the loan structure allows a separate amortizing term rate structure. */
export function canSeparateAmortizingRate(loan: api.SecuredMetaDataLoan) {
	return loan.loanType === 'loc'
		&& !loan.loanTermOnDemand
		&& (loan.revolvingTerm || 0) > 0
		&& (loan.amortizingTerm || 0) > 0;
}
